import { render, staticRenderFns } from "./ParkingItem.vue?vue&type=template&id=e1b63984&scoped=true"
import script from "./ParkingItem.vue?vue&type=script&lang=js"
export * from "./ParkingItem.vue?vue&type=script&lang=js"
import style0 from "./ParkingItem.vue?vue&type=style&index=0&id=e1b63984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b63984",
  null
  
)

export default component.exports